<template>
  <auto-select
    v-bind="$attrs"
    clear-icon="clear"
    :clearable="clearable"
    :value.sync="item[propertyName]"
    :items="items"
    :label="label"
    :rules="rules"
    item-value="Id"
    :disabled="disabled === true"
    :multiple="multiple === true ? true : false"
    @change="change"
    :slots="true"
    return-object
    :filter="filterFunc"
  >
    <template v-slot:selection="data">{{ trans(data.item) }}</template>
    <template v-slot:item="data">
      <v-list-item-content v-text="trans(data.item)"></v-list-item-content>
    </template>
  </auto-select>
</template>

<script>
import { mapGetters } from "vuex";
import { translate } from "../trans";
import AutoSelect from "../components/AutoSelect";
export default {
  name: "trans-select",
  props: [
    "item",
    "items",
    "rules",
    "label",
    "disabled",
    "propertyName",
    "clearable",
    "multiple",
  ],
  components: {
    AutoSelect,
  },
  mounted() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  methods: {
    filterFunc(item, search) {
      console.log(item);
      return (
        translate(item, this.language.language)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    trans(item) {
      // console.log("!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!2", item);
      return translate(item, this.language.language);
    },
    change(v) {
      // console.log('trans-select change ', this.item)
      this.$emit("change", v);
    },
  },
  watch: {
    items: {
      handler(v) {
        if (this.items && this.items.length === 1) {
          if (!this.clearable) {
            this.item[this.propertyName] = this.items[0];
          }
        }
      },
    },
  },
};
</script>